class Tabs {
	constructor() {
		this.tabsWrapper = document.querySelectorAll('.tabs__tab-content');
		this.tabsLink = document.querySelectorAll('.tabs__link a');
	}
	init() {
		this.tabsLink.forEach(el => el.addEventListener('click', (e) => {
			e.preventDefault();
			const clicked = e.target;
			if (clicked.classList.contains('active')) {
				return;
			}
			const tab = clicked.getAttribute('href');
			this.toggleTab(tab);
		}));
	}

	toggleTab(tab) {
		this.tabsLink.forEach(el => {
			el.parentElement.classList.remove('active');
			if (el.getAttribute('href') === tab) {
				el.parentElement.classList.add('active');
			}
		});

		this.tabsWrapper.forEach(el => {
			el.classList.remove('active');
			if (el.getAttribute('data-tab-id') === tab) {
				el.classList.add('active');
			}
		});
	}
}

export default new Tabs();
